/**
 * Controla a visualização do Google Street View no mapa
 *
 * @author Mozart Diniz Date: 21/12/2012 Time: 09:00
 *
 * @author Adalto Junior Date: 15/03/2013 Time: 10:00
 *
 * @author: Kete Martins
 * Date: 03/12/13
 * Time: 11:00
 */



Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};
Greenmile.Toolbar.Map.StreetView = Greenmile.Toolbar.Map.StreetView || {};

Greenmile.Toolbar.Map.StreetView = function (tabNameSelector, map) {

    this.displayed = false;
    this.actived = false;

    this.oldClickEvents = [];

    this.setActived = function (a) {
        this.actived = a;
    };

    this.setDisplayed = function (a) {
        this.displayed = a;
    };

    this.addListeners = function () {

        var mapEvent = function (self) {

            return function (map) {

                if(!self.oldClickEvents.length) {

                    if( map._events.click ) {
                        map._events.click.forEach(function(event){
                            self.oldClickEvents.push(event);
                        });
                    }

                    map.off("click");

                    map.on("click", function (e) {

                        const configs = Greenmile.Map.Utility.getMapProviderConfigs();

                        if(configs.google && !configs.google.configs.clientId) {

                            Greenmile.Map.Utility.openNewTabStreetView(e.latlng.lat, e.latlng.lng);

                        } else {
                            self.showStreetView(e.latlng.lat, e.latlng.lng);
                        }

                        self.removeCursor(this._container);

                    });

                }

            };

        }(this);

        var checkContainer = function (self) {
            return function () {
                self.checkContainer();
            };
        }(this);

        var changeCursor = function (self) {
            return function (map) {
                self.changeCursor(map._container);
            };
        }(this);


        var closeBtn = function (self) {
            return function () {
                var callback = function () {

                    self.street.setVisible(false);

                    self.setActived(false);

                    map._container.classList.remove('activeStreetView');

                };

                self.closeBtn(callback);

            };
        }(this);

        var active = function (self) {

            return function () {
                self.setActived(true);
            };

        }(this);

        $(tabNameSelector + " .btnStreetView").off("click");

        $(tabNameSelector + " .btnStreetView").on("click", function (e) {

            map.streetView = true;
            map._container.classList.add('activeStreetView');

            e.preventDefault();
            e.stopPropagation();

            changeCursor(map);

            checkContainer();

            mapEvent(map);

            active();
            closeBtn();

        });

    };

    this.checkContainer = function () {

        var container = $(this.containerQueryStr);

        if (container.length === 0) {

            var routeMaps = document.querySelector(tabNameSelector + ' #adjustsLayoutContainer') || document.querySelector(tabNameSelector + ' .containerRouteDetail');

            if (routeMaps) {
                $(routeMaps).append('<div class="streetView"></div><div class="streetViewCloseBtn"></div>');
            }

        }
    };

    this.setContainerQueryStr = function () {

        this.containerQueryStr = tabNameSelector + " .streetView";

    };

    this.showStreetView = function (lat, lng, povOptions) {

        var position, panoramaOptions;

        position = new google.maps.LatLng(lat, lng);

        if (typeof (options) !== "undefined") {

            panoramaOptions = {
                position: position,
                pov: povOptions
            };

        } else {

            panoramaOptions = {
                position: position,
                pov: {
                    heading: 180,
                    pitch: 0,
                    zoom: 1
                }
            };
        }

        if (this.actived === true) {

            $(tabNameSelector + " .streetViewCloseBtn").show();
            $(tabNameSelector + " .streetView").show();

            this.street = new google.maps.StreetViewPanorama(document
                .querySelector(this.containerQueryStr), panoramaOptions);

            this.street.setVisible(true);

            this.setDisplayed(true);

        }

    };

    this.changeCursor = function (conteiner) {

        const streetViewIcon = require("static/images/toolbars/streetViewIcon.cur");
        var allDivsOnMap = conteiner.getElementsByTagName('div');
        conteiner.style.cursor = 'url(' + streetViewIcon + '), default';
        for (var i = 0; i < allDivsOnMap.length; i++) {
            allDivsOnMap[i].style.cursor = 'url(' + streetViewIcon + '), default';
        }

    };

    this.removeCursor = function (conteiner) {

        var allDivsOnMap = conteiner.getElementsByTagName('div');
        conteiner.style.cursor = '';
        for (var i = 0; i < allDivsOnMap.length; i++) {
            allDivsOnMap[i].style.cursor = '';
        }

    };

    this.finish = function () {

        var theEnd = function (self) {

            return function (e) {

                if (e.keyCode === 27) {

                    $(tabNameSelector + " .streetViewCloseBtn").hide();
                    $(tabNameSelector + " .streetView").hide();

                    if (tabNameSelector !== "#SmartGeocode") {
                        self.setActived(false);
                    }

                    self.setDisplayed(false);

                }

            };

        }(this);

        $(tabNameSelector).off("keydown", theEnd);
        $(tabNameSelector).on("keydown", theEnd);

    };


    var closeBtnAction = function (callback, that) {

        var closeBtn = document.querySelector(
            tabNameSelector + " .streetViewCloseBtn"
        );
        var streetVContainer = document.querySelector(
            tabNameSelector + " .streetView"
        );

        closeBtn.style.display = 'none';
        streetVContainer.style.display = 'none';

        if (typeof (callback) !== "undefined") {
            callback();
        }

        that.setDisplayed(false);

        map.off("click");
        this.oldClickEvents.forEach(function(item){
            map.on('click', item.fn, item.ctx);
        });
        this.oldClickEvents = [];

    }.bind(this);

    this.closeBtn = function (callback) {
        var that = this;
        var element = document.querySelector(
            tabNameSelector + " .streetViewCloseBtn"
        );

        element.onclick = function () {

            closeBtnAction(callback, that);

        };

    };

    this.closeStreetView = function () {

        if (this.displayed) {

            var element = document.querySelector(
                tabNameSelector + " .streetViewCloseBtn"
            );

            element.click();

        }

    };

    var init = function (self) {

        self.setContainerQueryStr();

        self.checkContainer();

        self.addListeners();

        self.finish();

        return function () {
        };
    };

    init(this);

};
